import React, { useEffect } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

import { webhooksApi } from '../api';

function ConfirmWebhookEmailAlerts({ user, setAlert }) {
  const { token, id, app_id } = useParams();
  const location = useLocation();
  const confirmEmailAlert = async () => {
    try {
      const response = await webhooksApi.confirmWebhookEmailAlert(token);
      setAlert({ message: response.message, variant: response.success ? 'success' : 'danger' });
    } catch (error) {
      setAlert({ message: error, variant: 'warning' });
    }
  };

  useEffect(() => {
    confirmEmailAlert();
  }, []);

  return (
    <Navigate
      to={
        user
          ? {
              pathname:
                location.state && location.state.from
                  ? location.state.from
                  : `/dev/webhooks/${app_id}/${id}/detail`,
            }
          : { pathname: '/login' }
      }
    />
  );
}

export default ConfirmWebhookEmailAlerts;
